export default "__VITE_ASSET__BP272pe3__"